var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('graphic',{attrs:{"autoplay":_vm.autoplay,"delay":_vm.delay,"loop":_vm.loop,"loop-count":_vm.loopCount,"muted":true,"src":_vm.sources,"is-visible":_vm.isInViewport,"reg":"graphic"}})
}
var staticRenderFns = []

export { render, staticRenderFns }